import Logo from '@liveauctioneers/caterwaul-components/lib/Assets/Logo';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import * as React from 'react';
import styled from 'styled-components';

import CheckoutPageHeaderMeta from './CheckoutPageHeaderMeta';

type Props = {
    baseUrl: string;
    catalogId: number;
    houseId: number;
    setZipLoaded: Function;
};

const CheckoutPageHeader = ({ baseUrl, catalogId, setZipLoaded }: Props) => {
    return (
        <StyledHeader>
            <StyledHeaderContent>
                <CheckoutPageHeaderMeta
                    baseUrl={baseUrl}
                    catalogId={catalogId}
                    setZipLoaded={setZipLoaded}
                />
                <Link
                    route
                    to="/"
                >
                    <StyledLogo height="24px" />
                </Link>
            </StyledHeaderContent>
        </StyledHeader>
    );
};

export default CheckoutPageHeader;

const StyledHeader = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey400};
    margin-bottom: 64px;
    @media (max-width: ${({ theme }) => theme.breakpoints.tabletWidth}) {
        margin-bottom: 32px;
    }
`;

const StyledHeaderContent = styled.div`
    max-width: ${({ theme }) => theme.breakpoints.pageWidth};
    margin: 0 auto;
    padding: 0 32px;
`;

const StyledLogo = styled(Logo)`
    margin: 32px 0;
`;
